import * as colors from "@mui/material/colors"
import { createTheme } from "@mui/material"

const theme = createTheme({

  typography: {
    fontFamily: `Poppins, sans-serif`,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1400,

      mobile: 0,
      tablet: 640,
      laptop: 1025,
      desktop: 1200,
    },
  },
  palette: {
    ...colors,
    primary: {
      "100": "#e3effb",
      light: "#4ea6e2",
      main: "#2686c8",
      dark: "#196eb0",
    },


    secondary: {
      light: "#f2d952",
      main: "#edc322",
      dark: "#e5b216",
    },
    dark: {
      light: "#1a2732",
      main: "#2f4250",
      dark: "#314959",
    },
    other: {
      color1: "#223645",
      color2: "#7A8A9E",
      color3: "#1585db",
      color4: "#dbdfe5",
      color5: "#00000012",
      color6: "#15d500",
    }
  },

  // Customize componets
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          ".page-content": {
            padding: "24px",
            borderRadius: "12px",
            border: "1px solid #00000012",
          },
          ".content-listing": {
            width: "100%",
            overflow: "hidden",
            borderRadius: "12px",
            border: "1px solid #00000012",
          },
          ".overview-container": {
            gap: "16px",
            display: "flex",
            flexWrap: "wrap",
            marginBottom: "40px",
            alignItems: "center",
            justifyContent: "space-between",
          },
          ".filters-container": {
            gap: "24px",
            width: "100%",
            padding: "24px",
            display: "flex",
            overflow: "hidden",
            marginBottom: "24px",
            borderRadius: "12px",
            alignItems: "center",
            border: "1px solid #00000012",
            justifyContent: "space-between",
          },
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { labelvariant: "InputLabelA" },
              style: {
                color: "black",
                marginBottom: 2,
                display: "block",
                fontSize: "18px",
                fontWeight: "600",
                textTransform: "capitalize",
              }
            },
            {
              props: { labelvariant: "InputFieldB" },
              style: {
                marginBottom: 4,
                display: "block",
                fontSize: "15px",
                fontWeight: "500",
                color: "#333333",
                textTransform: "capitalize",

              }
            },
            {
              props: { variant: "specialistSignup" },
              style: {
                color: "black",
                display: "block",
                fontSize: "18px",
                fontWeight: "600",
                lineHeight: "1.5",
                marginBottom: "6px",
              }
            },
            {
              props: { variant: "selectType1" },
              style: {
                display: "block",
                color: "#223645",
                fontWeight: "600",
                lineHeight: "1.5",
                marginBottom: "6px",
              }
            },
            {
              props: { variant: "fileUploadLabel" },
              style: {
                width: "100%",
                padding: "13px",
                fontSize: "15px",
                color: "#ababab",
                lineHeight: "25px",
                borderRadius: "4px",
                border: "1px solid",
                borderColor: "#dedede",
              }
            },
          ]
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: "16px",
          boxShadow: "none",
          whiteSpace: "nowrap",
          textTransform: "initial",
          ":hover": { boxShadow: "none" },
          variants: [
            {
              props: { color: "primary", disabled: true },
              style: {
                opacity: "0.8",
                color: "white !important",
                backgroundColor: "#196eb0 !important",
              }
            },
            {
              props: { variant: "CtaButton" },
              style: {
                color: "#223645",
                fontWeight: "600",
                minWidth: "150px",
                borderRadius: "0",
                padding: "12px 24px",
                justifySelf: "center",
                justifyContent: "center",
                backgroundColor: "#edc322",
                ":hover": { backgroundColor: "#e5b216" },
                [theme.breakpoints.up("md")]: {
                  marginTop: "16px",
                },
              }
            },
            {
              props: { variant: "BannerButton" },
              style: {
                zIndex: "0",
                color: "#223645",
                fontWeight: "600",
                minWidth: "150px",
                borderRadius: "0",
                padding: "12px 28px",
                justifyContent: "center",
                backgroundColor: "white",
                position: "relative",
                "&:before": {
                  inset: "0",
                  width: "0px",
                  zIndex: "-1",
                  content: "''",
                  left: "initial",
                  position: "absolute",
                  backgroundColor: "#e5b216",
                  transition: "all 500ms ease",
                },
                ":hover": {
                  ":before": {
                    left: "0",
                    width: "100%"
                  }
                }
              }
            },
            {
              props: { variant: "BannerButtonSecondary" },
              style: {
                zIndex: "0",
                color: "white",
                fontWeight: "600",
                minWidth: "150px",
                borderRadius: "0",
                padding: "10px 28px",
                justifyContent: "center",
                border: "2px solid white",
                backgroundColor: "transparent",
                position: "relative",
                "&:before": {
                  inset: "0",
                  width: "0px",
                  zIndex: "-1",
                  content: "''",
                  left: "initial",
                  position: "absolute",
                  backgroundColor: "#e5b216",
                  transition: "all 500ms ease",
                },
                ":hover": {
                  ":before": {
                    left: "0",
                    width: "100%"
                  }
                }
              }
            },

            {
              props: { variant: "dayButton" },
              style: {
                width: "100%",
                padding: "8px 0",
                fontSize: "15px",
                fontWeight: 600,
                textTransform: "none",
                backgroundColor: "white",
                color: "#1a1a1a",
                border: "1px solid #ddd",
                "&:hover": {
                  backgroundColor: "#eee",
                },
                ".MuiTypography-root": {
                  display: "block",
                  fontSize: "10px",
                  lineHeight: 1.2,
                },
              }
            },
            {
              props: { variant: "activeDayButton" },
              style: {
                width: "100%",
                padding: "8px 0",
                fontSize: "15px",
                fontWeight: 600,
                textTransform: "none",
                backgroundColor: "#ff4877",
                color: "white",
                border: "1px solid #ff4877",
                "&:hover": {
                  backgroundColor: "#ff4877",
                },
                ".MuiTypography-root": {
                  display: "block",
                  fontSize: "10px",
                  lineHeight: 1.2,
                },
              }
            },
            {
              props: { variant: "slot" },
              style: {
                padding: "8px 12px",
                fontSize: "12px",
                borderColor: "#FF6B9D",
                backgroundColor: "white",
                color: "#1a1a1a",
                border: "1px solid #FF6B9D",
                textTransform: "none",
                ":hover": {
                  backgroundColor: "#FFE5ED",
                },
              }
            },
            {
              props: { variant: "slotSelected" },
              style: {
                padding: "8px 12px",
                fontSize: "12px",
                borderColor: "#FF6B9D",
                backgroundColor: "#FF6B9D",
                color: "white",
                border: "1px solid #FF6B9D",
                textTransform: "none",
                ":hover": {
                  backgroundColor: "#FF6B9D",
                },
              }
            },
            {
              props: { variant: "slotBooked" },
              style: {
                padding: "8px 12px",
                fontSize: "12px",
                backgroundColor: "#f5f5f5 !important",
                borderColor: "#e0e0e0",
                color: "#bdbdbd !important",
                border: "1px solid #e0e0e0",
                cursor: "not-allowed",
                textTransform: "none",
                ":hover": {
                  backgroundColor: "#f5f5f5",
                },
              }
            },
            {
              props: { btnvariant: "linkButton" },
              style: {
                fontSize: 15,
                fontWeight: "500",
                padding: "4px 8px",
                transition: "all 350ms ease",
                backgroundColor: "transparent",
                ":hover": {
                  textDecoration: "underline",
                  backgroundColor: "transparent",
                }
              }
            },
          ]
        })
      }
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          ctaLead: "p",
          bodyLead: "p",
          ctaNormal: "p",
          heroTitle: "p",
          bodyNormal: "p",
          sectionLead: "p",
          typographyA: "p",
          dialogNormal: "p",
          heroSubTitle: "p",
          displayLarge: "p",
          displayMedium: "p",
          topBannerTitle: "p",
          fileUploadLabel: "p",
          topBannerSubTitle: "p",
          dashboardSectionTitle: "h4",
        }
      },
      styleOverrides: {
        root: ({ theme }) => ({
          variants: [
            {
              props: { variant: "heroTitle" },
              style: {
                fontSize: "26px",
                fontWeight: "700",
                lineHeight: "42px",
                textAlign: "center",
                textShadow: "4px 4px 4px #00000073",
                [theme.breakpoints.up("sm")]: {
                  fontSize: "31px",
                  lineHeight: "47px",
                },
                [theme.breakpoints.up("lg")]: {
                  fontSize: "37px",
                  lineHeight: "56px",
                },
              }
            },
            {
              props: { variant: "heroSubTitle" },
              style: {
                fontSize: "18px",
                fontWeight: "500",
                textAlign: "center",
                textShadow: "4px 4px 4px #00000073",
              }
            },
            {
              props: { variant: "topBannerTitle" },
              style: {
                fontSize: "25px",
                fontWeight: "700",
                textAlign: "center",
                textShadow: "4px 4px 4px #00000073",
                [theme.breakpoints.up("md")]: {
                  fontSize: "32px",
                  textAlign: "center",
                },
                [theme.breakpoints.up("lg")]: {
                  fontSize: "45px",
                },
                [theme.breakpoints.up("xxl")]: {
                  fontSize: "54px",
                },
              }
            },
            {
              props: { variant: "topBannerSubTitle" },
              style: {
                fontSize: "15px",
                fontWeight: "500",
                textAlign: "center",
                textShadow: "4px 4px 4px #00000073",
                [theme.breakpoints.up("md")]: {
                  fontSize: "20px",
                },
                [theme.breakpoints.up("lg")]: {
                  fontSize: "25px",
                },
              }
            },
            {
              props: { variant: "displayLarge" },
              style: {
                fontSize: "32px",
                fontWeight: "700",
                lineHeight: "1.44",
                textAlign: "center",
                [theme.breakpoints.up("md")]: {
                  fontSize: "38px",
                }
              }
            },
            {
              props: { variant: "displayMedium" },
              style: {
                fontSize: "24px",
                fontWeight: "700",
                lineHeight: "1.44",
                textAlign: "center",
              }
            },
            {
              props: { variant: "bodyLead" },
              style: {
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "1.8",
              }
            },
            {
              props: { variant: "bodyNormal" },
              style: {
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "1.8",
              }
            },
            {
              props: { variant: "typographyA" },
              style: {
                fontSize: 30,
                component: "h2",
                marginBottom: 16,
                fontWeight: "700",
                color: "#223645",
              }
            },
            {
              props: { variant: "sectionLead" },
              style: {
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "1.44",
                letterSpacing: "3px",
                textTransform: "uppercase",
              }
            },
            {
              props: { variant: "fileUploadLabel" },
              style: {
                fontSize: "18px",
                color: "black",
                fontWeight: "600",
                marginBottom: "6px",
                lineHeight: "24px",
              }
            },
            {
              props: { variant: "ctaNormal" },
              style: {
                fontSize: "20px",
                fontWeight: "500",
                [theme.breakpoints.up("md")]: {
                  fontSize: "24px",
                },
              }
            },
            {
              props: { variant: "ctaLead" },
              style: {
                fontSize: "25px",
                fontWeight: "700",
                [theme.breakpoints.up("md")]: {
                  fontSize: "35px",
                },
              }
            },
            {
              props: { variant: "dashboardSectionTitle" },
              style: {
                fontSize: "24px",
                fontWeight: "500",
                marginBottom: "24px"
              }
            },
            {
              props: { variant: "dialogTitle" },
              style: {
                fontSize: 20,
                display: "block",
                fontWeight: "500",
                textAlign: "center",
                textTransform: "capitalize"
              }
            },
            {
              props: { variant: "dialogNormal" },
              style: {
                fontSize: 14,
                textAlign: "center",
                color: theme.palette.grey[700]
              }
            },
          ]
        })
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
          ":after": { display: "none" },
          ":before": { display: "none" },
          variants: [
            {
              props: { varianttype: "selectType1" },
              style: {
                ".MuiSelect-select.MuiSelect-select": {
                  height: "25px",
                  padding: "13px",
                  border: "1px solid #dedede",
                },
                fieldset: { border: "none" }
              }
            },
          ]
        }
      }
    },
    MuiPaper: {
      styleOverrides: { root: { boxShadow: "none" } },
      variants: [
        {
          props: { paperVariant: "dashboard" },
          style: {
            padding: 8,
            height: "100%",
            borderRadius: 6,
            borderColor: "#0000001f",
            boxShadow: "0 0 10px 0 #0000000a"
          }
        },
        {
          props: { paperVariant: "chatFilePreView" },
          style: {
            gap: 8,
            left: "0",
            padding: 8,
            right: "0",
            bottom: "100%",
            paddingTop: 12,
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            position: "absolute",
            "img": {
              maxWidth: 80,
              width: "100%",
              borderRadius: 6,
              aspectRatio: "1/1",
              objectFit: "cover",
            }
          }
        },
        {
          props: { paperVariant: "chatFilePostView" },
          style: {
            gap: 8,
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            "img": {
              maxWidth: 80,
              width: "100%",
              borderRadius: 6,
              aspectRatio: "1/1",
              objectFit: "cover",
            }
          }
        },
        {
          props: { paperVariant: "filePostViewA" },
          style: {
            padding: 4,
            maxWidth: 80,
            fontSize: 60,
            width: "100%",
            display: "grid",
            borderRadius: 6,
            fontWeight: "500",
            overflow: "hidden",
            aspectRatio: "1/1",
            position: "relative",
            placeContent: "center",
            backgroundColor: "#eee",
            "span": { fontSize: 12, textAlign: "center" },
            "div": {
              inset: "0",
              opacity: "0",
              fontSize: 32,
              color: "white",
              display: "grid",
              cursor: "pointer",
              position: "absolute",
              placeContent: "center",
              transition: "all ease 200ms",
              backgroundColor: "#3c3c3c5e",
              ":hover": { opacity: "1" },
            },
          }
        },
        {
          props: { paperVariant: "documentViewA" },
          style: {
            padding: 6,
            width: "100%",
            height: "100%",
            display: "grid",
            borderRadius: 6,
            fontWeight: "500",
            overflow: "hidden",
            position: "relative",
            backgroundColor: "#eee",
            gridTemplateRows: "1fr auto",
            "svg": { margin: "auto" },
            ".MuiTypography-root": {
              overflow: "hidden",
              textAlign: "center",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            },
          }
        },
        {
          props: { paperVariant: "menuContainerA" },
          style: ({ theme }) => ({
            gap: 1,
            padding: 1,
            marginBottom: 3,
            display: "flex",
            border: "1px solid",
            borderRadius: "6px",
            alignItems: "center",
            borderColor: theme.palette.divider,
          })
        },
        {
          props: { variant: "contentListing" },
          style: ({ theme }) => ({
            width: "100%",
            borderRadius: 12,
            overflow: "hidden",
            border: "1px solid",
            borderColor: theme.palette.other.color5
          })
        },
      ]
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          variants: [
            {
              props: { variant: "slickNext" },
              style: {
                top: "50%",
                right: "0",
                zIndex: "100",
                position: "absolute",
                backgroundColor: "white",
                transition: "all 350ms ease",
                transform: "translateY(-50%)",
                ":hover": { backgroundColor: "#e5e5e5" },
                boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                "& .MuiIcon-root": { fontSize: "30px", color: "#223645" }
              }
            },
            {
              props: { variant: "slickPrev" },
              style: {
                top: "50%",
                left: "0",
                zIndex: "100",
                position: "absolute",
                backgroundColor: "white",
                transition: "all 350ms ease",
                transform: "translateY(-50%)",
                ":hover": { backgroundColor: "#e5e5e5" },
                boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                "& .MuiIcon-root": {
                  fontSize: "30px", color: "#223645", transform: "rotate(180deg)"
                }
              }
            },
            {
              props: { variant: "chatMediaRemove" },
              style: {
                top: -8,
                right: -8,
                width: 18,
                height: 18,
                padding: 0,
                fontSize: 15,
                color: "white",
                position: "absolute",
                backgroundColor: theme.palette.error.light,
                ":hover": { backgroundColor: theme.palette.error.main },
              }
            },
            {
              props: { variant: "dialogCloseBtn", },
              style: {
                top: "10px",
                right: "10px",
                position: "absolute",
                color: theme.palette.grey[900],
                backgroundColor: theme.palette.grey[200],
                ":hover": { backgroundColor: theme.palette.grey[300] }
              }
            },
            {
              props: { variant: "fill", color: "error" },
              style: {
                color: theme.palette.primary[100],
                backgroundColor: theme.palette.error.main,
                ":hover": { backgroundColor: theme.palette.error.dark }
              }
            },
            {
              props: { variant: "fill", color: "success" },
              style: {
                color: theme.palette.primary[100],
                backgroundColor: theme.palette.success.main,
                ":hover": { backgroundColor: theme.palette.success.dark }
              }
            },
          ]
        })
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          variants: [
            {
              props: { variant: "custom" },
              style: {
                paddingTop: "13px !important",
                paddingLeft: "13px !important",
                paddingBottom: "13px !important",
                border: "1px solid #dedede",
                ".MuiAutocomplete-input.MuiAutocomplete-input": {
                  padding: "0",
                  height: "25px",
                },
                fieldset: { border: "none" }
              }
            }
          ]
        },
        option: {
          variants: [
            {
              props: { variant: "custom" },
              style: {
                color: "#223645",
                fontSize: "15px",
                fontWeight: "500",
              }
            }
          ]
        },
        tag: {
          variants: [
            {
              props: { variant: "custom" },
              style: {
                color: "#223645",
                fontWeight: "500",
              }
            }
          ]
        },
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          input: {
            "&:-webkit-autofill": {
              borderRadius: "inherit",
              WebkitBackgroundClip: "text",
            },
          },
          variants: [
            {
              props: { inputtype: "InputFieldB" },
              style: {
                ".MuiInputBase-root": {
                  padding: "4px 8px",
                  border: "1px solid #dcdcdc",
                  backgroundColor: "transparent !important",
                },
                ".MuiFormHelperText-root": {
                  margin: 0,
                  fontSize: 14,
                  marginTop: 4,
                },
                input: { padding: "4px 0" }
              }
            }
          ]
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { varianttype: "login" },
              style: {
                ".MuiInputBase-root": {
                  border: "1px solid #dcdcdc",
                  backgroundColor: "transparent !important",
                },
                ".MuiFormHelperText-root": {
                  margin: 0,
                  fontSize: 14,
                  marginTop: 4,
                },
                label: {
                  fontSize: "14px",
                  color: "#b8b8b8 !important",
                },
                input: {},
              }
            },
            {
              props: { varianttype: "specialistSignup" },
              style: {
                width: "100%",
                input: {
                  padding: "0",
                  height: "25px",
                },
                textarea: {
                  padding: "0",
                  minHeight: "25px",
                },
                ".MuiInputBase-root": {
                  padding: "13px",
                  border: "1px solid #dedede",
                  backgroundColor: "transparent !important",
                  "& ::placeholder": {
                    opacity: "1",
                    fontSize: "16.8px",
                    color: "#757575",
                  }
                },
              }
            },
          ]
        },
      }
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme }) => ({
          variants: [
            {
              props: { variant: "CommentChip" },
              style: {
                color: "#223645",
                fontWeight: "500",
                fontSize: "14px",
              }
            },
            {
              props: { variant: "statusChip" },
              style: {
                fontWeight: "500",
                lineHeight: "1.4",
                textTransform: "capitalize",
              }
            },
            {
              props: { variant: "specializationChip" },
              style: {
                height: 20,
                fontWeight: "500",
                lineHeight: "1.4",
                textTransform: "capitalize",
              }
            },
            {
              props: { variant: "statusChip", color: "orange" },
              style: {
                color: theme.palette.deepOrange[600],
                backgroundColor: theme.palette.deepOrange[50],
              }
            },
            {
              props: { variant: "statusChip", color: "green" },
              style: {
                color: theme.palette.green[600],
                backgroundColor: theme.palette.green[50],
              }
            },
            {
              props: { variant: "statusChip", color: "blue" },
              style: {
                color: theme.palette.blue[600],
                backgroundColor: theme.palette.blue[50],
              }
            },
            {
              props: { variant: "statusChip", color: "red" },
              style: {
                color: theme.palette.red[600],
                backgroundColor: theme.palette.red[50],
              }
            },
            {
              props: { variant: "statusChip", color: "red" },
              style: {
                color: theme.palette.red[600],
                backgroundColor: theme.palette.red[50],
              }
            },
            {
              props: { variant: "statusChip", color: "yellow" },
              style: {
                color: theme.palette.amber[600],
                backgroundColor: theme.palette.amber[50],
              }
            },
          ]
        })
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: "quetionnaire" },
              style: {
                margin: "0",
                width: "100%",
                padding: "13px",
                color: "#7A8A9E",
                fontSize: "15px",
                lineHeight: "25px",
                position: "relative",
                marginBottom: "12px",
                borderRadius: "12px",
                border: "1px dashed",
                borderColor: "#4ea6e2",
                ":has(.Mui-checked)": {
                  color: "white",
                  border: "1px solid",
                  borderColor: "#2686c8",
                  backgroundColor: "#2686c8",
                  ".MuiSvgIcon-root": { color: "white" }
                },
                ":after": {
                  inset: "0",
                  content: "''",
                  borderRadius: "12px",
                  position: "absolute",
                  border: "4px solid white",
                }
              }
            },
          ]
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: "faqListing" },
              style: {
                width: "100%",
                boxShadow: "none",
                border: "1px solid",
                borderColor: "#0000001f",
                borderRadius: "6px !important",
                ".MuiButtonBase-root": {
                  color: "#223645",
                  fontSize: "15px",
                },
                "&.Mui-expanded": { margin: "0" },
                "&.Mui-expanded .MuiButtonBase-root": {
                  color: "#2686c8",
                  backgroundColor: "#e3effb",
                }
              }
            },
            {
              props: { variant: "pricingPlan" },
              style: {
                boxShadow: "none",
                overflow: "hidden",
                border: "2px solid",
                borderColor: "#4ea6e2",
                borderRadius: "10px !important",
                ".MuiButtonBase-root.MuiAccordionSummary-root": {
                  color: "#223645",
                  fontSize: "15px",
                  backgroundColor: "#f3f3f3"
                },
                "&.Mui-expanded": { margin: "0" },
                ".MuiIconButton-root": {
                  padding: "3px",
                  fontSize: "22px",
                  color: "#2686c8",
                  backgroundColor: "#c2dff5",
                  ":hover": {
                    backgroundColor: "#8cc5ed",
                  }
                }
              }
            },
          ]
        }
      }
    },
    MuiSwitch: {
      styleOverrides: {
        root: ({ theme }) => ({
          variants: [
            {
              props: { variant: "cookie" },
              style: {
                padding: 8,
                '& .MuiSwitch-track': {
                  borderRadius: 22 / 2,
                  '&::before, &::after': {
                    content: '""',
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: 16,
                    height: 16,
                  },
                  '&::before': {
                    backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                      theme.palette.getContrastText(theme.palette.primary.main),
                    )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
                    left: 12,
                  },
                  '&::after': {
                    backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                      theme.palette.getContrastText(theme.palette.primary.main),
                    )}" d="M19,13H5V11H19V13Z" /></svg>')`,
                    right: 12,
                  },
                },
                '& .MuiSwitch-thumb': {
                  boxShadow: 'none',
                  width: 16,
                  height: 16,
                  margin: 2,
                },
              }
            }
          ]
        })
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: ({ theme }) => ({
          variants: [
            {
              props: { className: "adminTable1" },
              style: {
                ".MuiTableCell-root": {
                  color: "#223645",
                  whiteSpace: "nowrap",
                },
                "th": { backgroundColor: "#e3effb" },
                "tr:hover": { backgroundColor: "#00000012" },
                "td .MuiIconButton-root": {
                  color: "#e5b216 !important",
                },
                "td .MuiChip-label": {
                  color: "white",
                  lineHeight: "1",
                  overflow: "initial",
                },
              }
            },
            {
              props: { variant: "tableViewA" },
              style: {
                ".MuiTableCell-root": {
                  fontSize: 15,
                  whiteSpace: "nowrap",
                  color: theme.palette.other.color1,
                },
                "th": { backgroundColor: theme.palette.primary[100] },
                "tr:hover": { backgroundColor: theme.palette.other.color5 },
              }
            },
            {
              props: { className: "specialistTable" },
              style: {
                ".MuiTableCell-root": {
                  whiteSpace: "initial",
                  [theme.breakpoints.up("md")]: {
                    whiteSpace: "nowrap",
                  },
                },
                "th": { fontWeight: "500" },
                "table": { tableLayout: "fixed" },
                "tr:hover": { backgroundColor: "#00000012" },
                "td .MuiIconButton-root": {
                  color: "#7578ff",
                  transition: "all 400ms ease",
                  ":hover": {
                    color: "#635bff",
                    backgroundColor: "#dde3ff",
                  },
                },
              }
            },
          ]
        })
      }
    },

  }
})

export default theme